import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import ProjectPage from "@/pages/ProjectPage";
import SocietyPage from "@/pages/SocietyPage";

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    const lenis = window.__lenis;
    if (hash) {
      const t = setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) lenis ? lenis.scrollTo(el, { offset: -80 }) : el.scrollIntoView();
      }, 120);
      return () => clearTimeout(t);
    }
    lenis ? lenis.scrollTo(0, { immediate: true }) : window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.25, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App min-h-screen bg-[#050a06]">
      <div className="noise-overlay" aria-hidden="true" />
      <BrowserRouter>
        <ScrollManager />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/projects/:slug" element={<ProjectPage />} />
          <Route path="/projects/the-hermetica" element={<Navigate to="/projects/films" replace />} />
          <Route path="/projects/deadly-ambition" element={<Navigate to="/projects/tv-series" replace />} />
          <Route path="/projects/osirica" element={<Navigate to="/projects/books" replace />} />
          <Route path="/society" element={<SocietyPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-center" />
    </div>
  );
}

export default App;
